<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Willamette Valley Wineries</title>
<link href="template.css" rel="stylesheet" type="text/css"/>
<p class="title-head1">C<span class="small">ONTENTS</span></p>
<table>
<colgroup>
<col width="40px"/>
<col width="350px"/>
</colgroup>
<tbody>
<tr><td colspan="2"><span href="#/Title" title="Link target outside of Sample">Title Page</span></td></tr>
<tr><td colspan="2"><span href="#/Copyright" title="Link target outside of Sample">Copyright Page</span></td></tr>
<tr><td colspan="2"><span href="#/Dedication" title="Link target outside of Sample">Dedication</span></td></tr>
<tr><td colspan="2"><a href="#/Acknowledgment#Ack">Acknowledgments</a></td></tr>
<tr><td colspan="2"><a href="#/Introduction#Intro">Introduction</a></td></tr>
<tr><td><span href="#/Chapter1#C1" title="Link target outside of Sample">1.</span></td><td><span href="#/Chapter1#C1" title="Link target outside of Sample">The Pioneers</span></td></tr>
<tr><td><span href="#/Chapter2#C2" title="Link target outside of Sample">2.</span></td><td><span href="#/Chapter2#C2" title="Link target outside of Sample">Setting the Infrastructure</span></td></tr>
<tr><td><span href="#/Chapter3#C3" title="Link target outside of Sample">3.</span></td><td><span href="#/Chapter3#C3" title="Link target outside of Sample">Teaching the Newcomers</span></td></tr>
<tr><td><span href="#/Chapter4#C4" title="Link target outside of Sample">4.</span></td><td><span href="#/Chapter4#C4" title="Link target outside of Sample">Telling the World about Pinot Noir</span></td></tr>
<tr><td><span href="#/Chapter5#C5" title="Link target outside of Sample">5.</span></td><td><span href="#/Chapter5#C5" title="Link target outside of Sample">Experiencing the Terroir</span></td></tr>
<tr><td><span href="#/Chapter6#C6" title="Link target outside of Sample">6.</span></td><td><span href="#/Chapter6#C6" title="Link target outside of Sample">Looking to the Future</span></td></tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?1465843c